import { ExportInterfaceConfigurationRESTAuthType, ImportConfigurationClientAccessType, ImportConfigurationTransferType, ImportConfigurationType, ImportType } from './../../../../../base/models/models.swagger.generated';
import { EnumTranslationService } from './../../../../../base/services/enum-translation.service';
import { DropDownConstantsFactory } from './../../../../../base/shared/syncfusion/dropdown-constants-factory';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ImportConfigurationGeneralFormType } from './configuration-form-general-form-type';
import { ImportConfigurationEditFormsCoordinatorService } from '../import-configuration-edit-forms-coordinator.service';
import { Component, OnInit, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ConfigurationFormGeneralGridComponent } from './configuration-form-general-grid/configuration-form-general-grid.component';
import { YesNoGroupButtonComponent } from '../../../../../base/shared/yes-no-group-button/yes-no-group-button.component';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { AppErrorMessagesComponent } from '../../../../../base/error-messages/app-error-messages.component';
import { AuthService } from 'src/app/base/services/auth.service';

@Component({
    selector: 'app-configuration-form-general',
    templateUrl: './configuration-form-general.component.html',
    styleUrls: ['./configuration-form-general.component.scss'],
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, DropDownListModule, YesNoGroupButtonComponent, ConfigurationFormGeneralGridComponent, TranslateModule]
})
export class ConfigurationFormGeneralComponent implements OnInit, AfterViewChecked {

  public get configurationFormGeneral(): FormGroup<ImportConfigurationGeneralFormType> {
    return this.formsCoordinationService.configurationFormGeneral;
  }

  public ImportConfigurationTransferType = ImportConfigurationTransferType;

  public enumDropdownSettings = DropDownConstantsFactory.createNumericEnumDropdownSettings();
  public transferTypes = this.enumTranslateService.translateNumericEnum(ImportConfigurationTransferType, 'i18n.domain.import-configuration.enums.transfer-type.');
  public importTypes = this.enumTranslateService.translateNumericEnum(ImportType, 'i18n.domain.import-configuration.enums.import-type.');

  public get showUserAssignmentGrid(): boolean {
    if(this.formsCoordinationService.configurationFormGeneral.controls.type.value == ImportConfigurationType.Template){
      return false;
    }

    if (this.configurationFormGeneral.controls.transferType.value == ImportConfigurationTransferType.ManualImport
      || this.configurationFormGeneral.controls.clientAccessType.value == ImportConfigurationClientAccessType.Global) {
      return false;
    }

    return (this.configurationFormGeneral.controls.transferType.value != null
      && this.configurationFormGeneral.controls.transferType.value != ImportConfigurationTransferType.FTPClient
    && this.configurationFormGeneral.controls.transferType.value != ImportConfigurationTransferType.Email
    && this.configurationFormGeneral.controls.transferType.value != ImportConfigurationTransferType.Acodis
    && this.configurationFormGeneral.controls.transferType.value != ImportConfigurationTransferType.Magento
    && this.configurationFormGeneral.controls.transferType.value != ImportConfigurationTransferType.Zir

    && this.configurationFormGeneral.controls.transferType.value != ImportConfigurationTransferType.REST)
    || (this.configurationFormGeneral.controls.transferType.value == ImportConfigurationTransferType.REST
      && this.formsCoordinationService.configurationFormRest.controls.restAccessType.value == ExportInterfaceConfigurationRESTAuthType.BearerToken);
  }

  constructor(
    public formsCoordinationService: ImportConfigurationEditFormsCoordinatorService,
    private enumTranslateService: EnumTranslationService,
    private cdr: ChangeDetectorRef,
    public authService: AuthService
  ) { }

  ngOnInit() {
    this.configurationFormGeneral.controls.transferType.valueChanges.subscribe(() => {
      this.formsCoordinationService.setValidatorsForGeneralConfigForm();
    });
    this.configurationFormGeneral.controls.type.valueChanges.subscribe(() => {
      this.formsCoordinationService.setValidatorsForGeneralConfigForm();
    });
  }

  public ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

}
